module.exports = __webpack_public_path__ + "static/media/edelgard-vonhresvelg.a32f883e.png";